<div class = "content">
    <div class = "content-header">
        <h3 class = "content-title">{{ title }}</h3>
        <fa-icon [icon]="faX" class="icon-close" (click)="onNo()"></fa-icon>
    </div>
    <div class = "content-body">
        <p>
            {{ description }}
        </p>
    </div>
    <div class = "content-footer">
        <button class = "buy-button" (click) = "onFirstButtonClick()">{{ textFirstButton }}</button>
        <button class = "go-to-shopping-cart-button" (click) = "onSecondButtonClick()">{{ textSecondButton }}</button>
    </div>
</div>



